<template>
  <div class="relative w-full flex flex-col group">
    <textarea
      ref="textarea"
      :value="modelValue"
      :class="[
        'w-full min-h-[1.5rem] px-2 pt-2 border rounded bg-surface text-fg leading-[1.5] resize-none box-border overflow-hidden flex-shrink-0 font-[inherit] focus:outline-none focus:border-accent',
        actionButtons ? 'pb-9' : 'pb-2',
        hasFieldError ? 'border-danger' : 'border-border',
      ]"
      :placeholder="placeholder"
      :aria-label="ariaLabel ?? placeholder"
      @input="handleInput"
      @change="change"
      @keydown.ctrl.enter.prevent="$emit('submit')"
      @keydown.esc="$emit('cancel')"
    />
    <font-awesome-icon
      v-if="clearable && modelValue"
      :icon="['fal', 'times']"
      class="absolute right-2 top-2 p-2 cursor-pointer pointer-events-auto z-[2] text-fg-muted hover:text-fg"
      @click="clearInput"
    />
    <div v-if="actionButtons" class="hidden group-focus-within:flex absolute right-2 bottom-2 gap-2 z-[2]">
      <BaseIconButton
        icon="times"
        type="cancel"
        size="small"
        title="Avbryt"
        aria-label="Avbryt"
        @click="$emit('cancel')"
      />
      <BaseIconButton
        :icon="submitIcon"
        type="primary"
        size="small"
        :title="submitText"
        :aria-label="submitText"
        @click="$emit('submit')"
      />
    </div>
    <div v-if="hasFieldError" class="text-danger text-sm mt-1">
      {{ displayError }}
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import BaseIconButton from '@/components/BaseComponents/BaseIconButton.vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  ariaLabel: { type: String, default: null },
  submitIcon: {
    type: String,
    default: 'paper-plane',
  },
  submitText: {
    type: String,
    default: 'lagre',
  },
  actionButtons: {
    type: Boolean,
    default: false,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  /** Tom streng = ingen feil (samme kontrakt som BaseInput). */
  error: {
    type: String,
    default: '',
  },
});

const displayError = computed(() => String(props.error ?? '').trim());
const hasFieldError = computed(() => displayError.value.length > 0);

const emit = defineEmits(['update:modelValue', 'submit', 'cancel', 'change']);

const textarea = ref(null);

function handleInput (event) {
  emit('update:modelValue', event.target.value);
  autoGrow();
}

function change (event) {
  emit('change', event.target.value);
}

function autoGrow () {
  // Reset height to auto to get the correct scrollHeight
  textarea.value.style.height = 'auto';
  // Set height to scrollHeight to expand
  textarea.value.style.height = textarea.value.scrollHeight + 'px';
}

function clearInput () {
  emit('update:modelValue', null);
  emit('change', null);
}

onMounted(() => {
  autoGrow();
});
</script>

